import GetGiftingUndeliverableDates from '@/services/cms/undeliverableDatesService/GetGiftingUndeliverableDates';

export default class UndeliverableDatesService {
    getGiftingUndeliverableDates() {
        return (new GetGiftingUndeliverableDates()).handle();
    }
};
